import { render, staticRenderFns } from "./Knowhow.vue?vue&type=template&id=4277e8f0&scoped=true&"
import script from "./Knowhow.vue?vue&type=script&lang=ts&"
export * from "./Knowhow.vue?vue&type=script&lang=ts&"
import style0 from "./Knowhow.vue?vue&type=style&index=0&id=4277e8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4277e8f0",
  null
  
)

export default component.exports